import {Component, Input, OnInit} from '@angular/core';
import {DefaultDeviceCatalog} from "../../../../../model/default-device-catalog";

@Component({
  selector: 'app-default-device-overview',
  templateUrl: './default-device-overview.component.html',
  styleUrls: ['./default-device-overview.component.scss']
})
export class DefaultDeviceOverviewComponent implements OnInit {

  @Input()
  public defaultDeviceCatalog: DefaultDeviceCatalog;

  constructor() {
  }

  ngOnInit(): void {
  }

}
